<div
    id="customers-by-exposure"
    [ngClass]="{ 'min-page-width-large-up': !(dataSource?.loading$ | async) }"
>
    <lsq-banner
        [reportName]="(isSmallDeviceStream | async) ? null : title"
        [titleText]="(isSmallDeviceStream | async) ? title : null"
        [hasContent]="true"
        [service]="listCustomerSummaryService"
        [hideExport]="hideExport"
        [includeDateFilterStringPlaceholder]="false"
    >
    </lsq-banner>

    <div class="container-fluid page-container" *ngIf="dataSource">
        <lsq-report-actions-layout layoutWidth="md">
            <form id="customers-filters-form" [formGroup]="customersFiltersFormGroup">
                <div id="customers-filters-customer-name">
                    <lsq-input
                        placeholder="Enter Customer Name"
                        formControlName="customerName"
                        [name]="'customerName'"
                        [prependIcon]="[icons.FaMagnifyingGlassSolid, color.GraphicGray]"
                        [group]="customersFiltersFormGroup"
                    >
                    </lsq-input>
                </div>
            </form>
        </lsq-report-actions-layout>
        <div class="row">
            <div class="col">
                <lsq-data-table-mobile
                    *ngIf="responsiveService.smBelow | async"
                    [dataSource]="dataSource"
                    [isPaginated]="true"
                    [cardsAreExpandable]="false"
                >
                    <ng-template #mobileCardHeader let-row="row">
                        <div class="mtc-header-content" (click)="handleMobileCardClick(row)">
                            <div class="mtc-header-title">
                                {{ row.name }}
                            </div>
                            <div class="customers-mtc-basic-info row">
                                <div class="col">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="customers-mtc-basic-info-header small-uppercase"
                                        >
                                            {{ arBalanceHeader }}
                                        </span>
                                        <span class="customers-mtc-basic-info-value">
                                            {{ row.arBalance | lsqCurrency }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="customers-mtc-basic-info-header small-uppercase"
                                        >
                                            {{ percentOfArHeader }}
                                        </span>
                                        <span class="customers-mtc-basic-info-value">
                                            {{
                                                row.percentOfAr > 0 && row.percentOfAr < 1
                                                    ? '< 1%'
                                                    : (row.percentOfAr | lsqPercent)
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="customers-mtc-basic-info row">
                                <div class="col">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="customers-mtc-basic-info-header small-uppercase"
                                        >
                                            {{ creditLimitHeader }}
                                        </span>
                                        <span class="customers-mtc-basic-info-value">
                                            {{ row.creditLimit | lsqCurrency }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="customers-mtc-basic-info-header small-uppercase"
                                        >
                                            {{ creditUtilizationRateHeader }}
                                        </span>
                                        <span class="customers-mtc-basic-info-value">
                                            {{
                                                row.percentOfCreditLimit > 0 &&
                                                row.percentOfCreditLimit < 1
                                                    ? '< 1%'
                                                    : (row.percentOfCreditLimit | lsqPercent)
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="customers-mtc-basic-info row">
                                <div class="col">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="customers-mtc-basic-info-header small-uppercase"
                                        >
                                            {{ currentArHeader }}
                                        </span>
                                        <span class="customers-mtc-basic-info-value">
                                            {{ row.currentAr | lsqCurrency }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="customers-mtc-basic-info-header small-uppercase"
                                        >
                                            {{ ar1To30Header }}
                                        </span>
                                        <span class="customers-mtc-basic-info-value">
                                            {{ row.ar1To30Days | lsqCurrency }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="customers-mtc-basic-info row">
                                <div class="col">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="customers-mtc-basic-info-header small-uppercase"
                                        >
                                            {{ ar31To60Header }}
                                        </span>
                                        <span class="customers-mtc-basic-info-value">
                                            {{ row.ar31To60Days | lsqCurrency }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="customers-mtc-basic-info-header small-uppercase"
                                        >
                                            {{ ar61PlusHeader }}
                                        </span>
                                        <span class="customers-mtc-basic-info-value">
                                            {{ row.ar61PlusDays | lsqCurrency }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="customers-mtc-basic-info row">
                                <div class="col">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="customers-mtc-basic-info-header small-uppercase"
                                        >
                                            {{ dso12MonthsHeader }}
                                            <lsq-icon
                                                *ngIf="!!dso12MonthsPopoverContent"
                                                [attr.tabindex]="0"
                                                [type]="icons.QuestionCircleLight"
                                                [popoverOnHover]="true"
                                                [height]="11"
                                                [width]="13"
                                                [popover]="dso12MonthsPopoverContent"
                                                [popoverPlacement]="tooltipPlacement"
                                                [color]="color.Slate"
                                            >
                                            </lsq-icon>
                                        </span>
                                        <span class="customers-mtc-basic-info-value">
                                            <div
                                                *ngIf="
                                                    row.fieldsWithAsterisks.includes(
                                                        'dso3Months'
                                                    ) || row.dso12Months == 0
                                                "
                                            >
                                                --
                                            </div>
                                            <div
                                                *ngIf="
                                                    !row.fieldsWithAsterisks.includes(
                                                        'dso3Months'
                                                    ) && row.dso12Months != 0
                                                "
                                            >
                                                <div *ngIf="row.dso12Months != 0">
                                                    {{ row.dso12Months }}
                                                    <div
                                                        *ngIf="
                                                            row.fieldsWithAsterisks.includes(
                                                                'dso12Months'
                                                            )
                                                        "
                                                        class="asterisk"
                                                    >
                                                        *
                                                    </div>
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="customers-mtc-basic-info-header small-uppercase"
                                        >
                                            {{ dso3MonthsHeader }}
                                            <lsq-icon
                                                *ngIf="!!dso3MonthsPopoverContent"
                                                [attr.tabindex]="0"
                                                [type]="icons.QuestionCircleLight"
                                                [popoverOnHover]="true"
                                                [height]="11"
                                                [width]="13"
                                                [popover]="dso3MonthsPopoverContent"
                                                [popoverPlacement]="tooltipPlacement"
                                                [color]="color.Slate"
                                            >
                                            </lsq-icon>
                                        </span>
                                        <span class="customers-mtc-basic-info-value">
                                            <div *ngIf="row.dso3Months != 0">
                                                {{ row.dso3Months }}
                                                <div
                                                    *ngIf="
                                                        row.fieldsWithAsterisks.includes(
                                                            'dso3Months'
                                                        )
                                                    "
                                                    class="asterisk"
                                                >
                                                    *
                                                </div>
                                            </div>
                                            <div *ngIf="row.dso3Months == 0">
                                                --
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </lsq-data-table-mobile>

                <lsq-data-table
                    *ngIf="!(responsiveService.smBelow | async)"
                    [dataSource]="dataSource"
                    [isPaginated]="true"
                    [hasStickyHeader]="true"
                    (takeChanged)="handleTakeChange($event)"
                >
                    <lsq-row-count-column></lsq-row-count-column>

                    <ng-template #noDataContent>
                        <no-data-box [titleText]="noDataTitle"> </no-data-box>
                    </ng-template>
                    <lsq-column
                        [column]="{
                            key: 'name',
                            header: customerHeader,
                            mobileHeader: 'Submission Date',
                            sortable: true
                        }"
                    >
                        <ng-template [custom-cell] let-row="row">
                            <a
                                class="light-font customer-name"
                                [routerLink]="[
                                    getCustomerLink(
                                        customerOverviewRouterLinkUrl,
                                        row.thirdPartyKey
                                    )
                                ]"
                            >
                                {{ row.name }}
                            </a>
                        </ng-template>
                    </lsq-column>

                    <lsq-currency-column
                        [column]="{
                            key: 'arBalance',
                            header: arBalanceHeader,
                            sortable: true
                        }"
                    ></lsq-currency-column>

                    <lsq-column
                        [column]="{
                            key: 'percentOfAr',
                            header: percentOfArHeader,
                            sortable: true
                        }"
                        alignRight="true"
                    >
                        <ng-template [custom-cell] let-row="row">
                            {{
                                row.percentOfAr > 0 && row.percentOfAr < 1
                                    ? '< 1%'
                                    : (row.percentOfAr | lsqPercent)
                            }}
                        </ng-template>
                    </lsq-column>

                    <lsq-currency-column
                        [column]="{
                            key: 'creditLimit',
                            header: creditLimitHeader,
                            sortable: true
                        }"
                    ></lsq-currency-column>

                    <lsq-column
                        [column]="{
                            key: 'percentOfCreditLimit',
                            header: creditUtilizationRateHeader,
                            sortable: true
                        }"
                        alignRight="true"
                    >
                        <ng-template [custom-cell] let-row="row">
                            {{
                                row.percentOfCreditLimit > 0 && row.percentOfCreditLimit < 1
                                    ? '< 1%'
                                    : (row.percentOfCreditLimit | lsqPercent)
                            }}
                        </ng-template>
                    </lsq-column>

                    <lsq-currency-column
                        [column]="{
                            key: 'currentAr',
                            header: currentArHeader,
                            sortable: true
                        }"
                    ></lsq-currency-column>

                    <lsq-currency-column
                        [column]="{
                            key: 'ar1To30Days',
                            header: ar1To30Header,
                            sortable: true
                        }"
                    ></lsq-currency-column>

                    <lsq-currency-column
                        [column]="{
                            key: 'ar31To60Days',
                            header: ar31To60Header,
                            sortable: true
                        }"
                    ></lsq-currency-column>

                    <lsq-currency-column
                        [column]="{
                            key: 'ar61PlusDays',
                            header: ar61PlusHeader,
                            sortable: true
                        }"
                    ></lsq-currency-column>

                    <lsq-column
                        [column]="{
                            key: 'dso12Months',
                            header: dso12MonthsHeader,
                            mobileHeader: 'Submission Date',
                            sortable: true,
                            headerPopoverContent: dso12MonthsPopoverContent,
                            popoverIcon: true
                        }"
                        alignRight="true"
                    >
                        <ng-template [custom-cell] let-row="row">
                            <div
                                *ngIf="
                                    row.fieldsWithAsterisks.includes('dso3Months') ||
                                    row.dso12Months == 0
                                "
                            >
                                --
                            </div>
                            <div
                                *ngIf="
                                    !row.fieldsWithAsterisks.includes('dso3Months') &&
                                    row.dso12Months != 0
                                "
                            >
                                <div *ngIf="row.dso12Months != 0">
                                    {{ row.dso12Months }}
                                    <div
                                        *ngIf="row.fieldsWithAsterisks.includes('dso12Months')"
                                        class="asterisk"
                                    >
                                        *
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </lsq-column>

                    <lsq-column
                        [column]="{
                            key: 'dso3Months',
                            header: dso3MonthsHeader,
                            mobileHeader: 'Submission Date',
                            sortable: true,
                            headerPopoverContent: dso3MonthsPopoverContent,
                            popoverIcon: true
                        }"
                        alignRight="true"
                    >
                        <ng-template [custom-cell] let-row="row">
                            <div *ngIf="row.dso3Months != 0">
                                {{ row.dso3Months }}
                                <div
                                    *ngIf="row.fieldsWithAsterisks.includes('dso3Months')"
                                    class="asterisk"
                                >
                                    *
                                </div>
                            </div>
                            <div *ngIf="row.dso3Months == 0">
                                --
                            </div>
                        </ng-template>
                    </lsq-column>
                </lsq-data-table>
            </div>
        </div>
    </div>
</div>
